import React from 'react'
import { ImageView } from './components/imageview';
import { Split } from './components/split';
import { Document } from './components/document';
import './home.css';

export class Money extends React.Component {

    render() {
        return (
            <Split>
                <Document>
                    <h2>But how in the world will you make money?</h2>
                    <p>Largely through a token-based pricing model. You pay for training tokens, input tokens, and output tokens. Similar to OpenAI's model with competitive rates and, of course, with online training (which OpenAI lacks).</p>
                    <p>Initially, a prepaid credit system, so you pay in advance—so our customers don't get any nasty surprises when the bill comes. When you run out of credit, the system stops working until you add more money to your account. This eliminates the need for handling bad debt, etc.</p>
                    <p>This gives us revenue upfront which we can use to buy the GPUs we need to meet demand. We can scale with growing demand without requiring so much capital.</p>
                    <p>Alternatively, a subscription model can be considered at a later date. These are relatively popular, but have their downsides as well. The infrequent users subsidize the super users.</p>
                </Document>
                <ImageView src="/images/user.png"/>
            </Split>
        );
    }
}

